export const NEW_ROW_ID = '-new-row';
